export const scanMixin = {
  methods: {
    validateScanType({ type, q }) {
      const oldShelf = /^[A-Z][0-9][0-9][0-9]$/.test(q)
      if (oldShelf) {
        q = `SH-${q.substr(0, 1)}0${q.substr(1, 1)}-${q.substr(2, 2)}`
      }
      switch (type) {
        case 'shelfSpace':
          return /^SH-[A-Z](?:(0)[1-9]|[1-9][0-9])-[0-9][0-9]$/.test(q)
        case 'boxSpace':
          return /W[0-9]-[0-9][0-9]/.test(q)
        case 'productId':
          return /A[0-9][0-9][0-9][0-9]/.test(q) || /a[0-9][0-9][0-9][0-9]/.test(q)
        case 'ean':
          return /^\d+$/.test(q)
        case 'string':
          return true
      }
    },
    getScanResult({ type, q }) {
      switch (type) {
        case 'shelfSpace': {
          // legacy lösung
          const oldShelf = /^[A-Z][0-9][0-9][0-9]$/.test(q)
          if (oldShelf) {
            q = `SH-${q.substr(0, 1)}0${q.substr(1, 1)}-${q.substr(2, 2)}`
          }
          const shelfSpace = q.replace('SH-', '')
          const shelf = _.find(this.$store.state.shelves, { id: shelfSpace.split('-')[0] })
          const shelfSpaceItems = shelf?.spaces?.[shelfSpace.split('-')[1]]?.items ?? null
          if (shelfSpaceItems) {
            return {
              data: shelfSpaceItems,
              redirect: { name: 'shelf', params: { shelfSpaceId: shelfSpace } }
            }
          } else {
            return {
              error: {
                title: 'Shelf Space Not Found',
                text: `Couldn't find the shelf space ${shelfSpace}`
              }
            }
          }
        }
        case 'boxSpace':
          return 'BOX'
        case 'productId': {
          const product = _.find(this.$store.state.products, { id: q.toUpperCase() })
          if (product) {
            return {
              data: product,
              redirect: { name: 'product', params: { productId: product.id } }
            }
          } else {
            return {
              error: {
                title: 'Product Not Found',
                text: `Couldn't find a product with the ID ${q}`
              }
            }
          }
        }
        case 'ean': {
          const product = _.find(this.$store.state.products, { eans: [{ ean: q }] })
          if (product) {
            product.amount = _.find(product.eans, { ean: q }).amount
          }
          if (product) {
            return {
              data: product,
              redirect: { name: 'product', params: { productId: product.id } }
            }
          } else {
            return {
              error: {
                title: 'Product Not Found',
                text: `Couldn't find a product with the EAN ${q}`
              }
            }
          }
        }
        case 'string': {
          return true
        }
      }
    }
  }
}
